import { HtmlHTMLAttributes } from 'react';
import { useMemo } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';

import { useWebp } from 'hooks/useWebp';

interface IImageProps extends HtmlHTMLAttributes<HTMLImageElement> {
  src: string;
  srcWebp?: string;
  alt?: string;
  className?: string;
  width?: number;
  height?: number;
}

const Image: React.FC<IImageProps> = ({ src, srcWebp, alt, className, width, height }) => {
  const webp = useWebp();

  const imageURL = useMemo(() => {
    if (!srcWebp) return src;
    return webp.enabled ? srcWebp : src;
  }, [src, srcWebp, webp.enabled]);

  return (
    <LazyLoadImage
      src={imageURL}
      className={`img ${className || ''}`}
      width={width}
      height={height}
      alt={alt}
      effect="blur"
    />
  );
};

export default Image;
